import { DateTime } from 'luxon';

export const isAmPm = (datetime: DateTime) => {
  return datetime.hour < 12 ? 'am' : 'pm';
};
